<template>
  <div class="app-footer" :class="getAppFooterClass">
    <information-popup
    v-if="this.currentPage == 'timetable'"
      class="information-popup"
      :latestMessageOnly="true"
      :messageType="messageType"
    />   
    <speech-player
    v-if="showAudioPlayer"
    class="audio-player"
    :messageType="messageType"
    />
  </div>
</template>
  
  <script>
import InformationPopup from "./InformationPopup.vue";
import SpeechPlayer from "../SpeechPlayer.vue";
  import { MessageLocation } from "../../constants";
import { mapState , mapMutations} from "vuex";

export default {
  components: {
    SpeechPlayer,
    InformationPopup,
  },
  props: {
    messageType: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isMessagesOpen:
        this.messageType === MessageLocation.FOOTER ? false : true,
      isFullScreenMessage:
        this.messageType === MessageLocation.FOOTER ||
        this.messageType === MessageLocation.FULL_SCREEN_PAGED
          ? false
          : true,
    };
  },
  watch: {
    messageType: {
      handler: function (newVal) {
        if (newVal === MessageLocation.FOOTER) {
          this.setPopupMinimised(true)
        } else {
          this.setPopupMinimised(false)
        }
        if (
          newVal === MessageLocation.FOOTER ||
          newVal === MessageLocation.FULL_SCREEN_PAGED
        ) {
          this.isFullScreenMessage = false;
        } else {
          this.isFullScreenMessage = true;
        }
      },
      immediate: true,
    },
  },
    computed: {
      ...mapState(["currentPage", "audioEnabled", "popupMinimised", "popupPreviouslyMinimised"]),
      showAudioPlayer()
      {
        return this.audioEnabled && this.currentPage != "links";
      },
      getAppFooterClass() {
      if (this.popupMinimised) return "app-footer-closed";

      let classes =
        this.isFullScreenMessage && this.currentPage === "timetable"
          ? "app-footer-large"
          : "app-footer-small";
      return classes;
    },
    },
    methods: {
    ...mapMutations(["setPopupMinimised"]),

    },
    mounted() {
      if (this.popupMinimised == true || this.popupPreviouslyMinimised == true) {
        this.setPopupMinimised(true)
      } else {
        this.setPopupMinimised(this.messageType === MessageLocation.FOOTER)
      }
  },
};
</script>
  
  <style scoped>
  .information-popup{
    height: 10vh;
  }
.progress-bar {
  min-height: 3vh !important;
  max-height: 3vh !important;
  background-color: rgb(var(--v-theme-background-dark)) !important;
  border: none !important;
  border-radius: 0px;
  width: 100%;
  overflow-y: hidden;
  flex: 1;
}

.app-footer {
  position: relative;
  text-align: center;
  width: 100%;
  color: black;
  background-color: lightgrey;
}

.app-footer-large {
  height: calc(100vh - (var(--app-head-top) + var(--toolbar-height)));
  z-index: 1010;
}
.app-footer-small {
  max-height: 50vh;
}
.app-footer-closed {
  height: auto;
}
.audio-player {
  flex: 1;
  width: 100%;
  min-height: 15vh;
  max-height: 15vh;

  background-color: rgb(var(--v-theme-nav-btn-text)) !important;
}
.messages {
  flex: 1;
  min-height: 5vh;
  position: relative;
  overflow: auto;
}
.progress-bar {
  flex: 1;
  min-height: 2vh !important;
  max-height: 2vh !important;
  background-color: green;
}
</style>